import React, { useState } from "react";
import "./PeachPayment.css";

export default function PeachPayment() {
  const [version, setVersion] = useState("legacy");

  return (
    <div className="coin-container">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span>Home</span> / <span>Payment Wallets</span> / <span>Create New</span>
      </div>

      {/* Title */}
      <h2 className="page-title">Update Peach Payment</h2>

      {/* Card */}
      <div className="card">
        <div className="card-header">Peach Payment Configuration</div>
        <div className="card-body">
          
          {/* Form Inputs */}
          <div className="form-row">
            <div className="form-col">
              <label>Entry ID</label>
              <input type="text" placeholder="" />
            </div>
            <div className="form-col">
              <label>Client ID</label>
              <input type="text" placeholder="" />
            </div>
            <div className="form-col">
              <label>Merchant ID</label>
              <input type="text" placeholder="" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-col">
              <label>Client Secret</label>
              <input type="text" placeholder="" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-col">
              <label>currency</label>
              <input type="text" placeholder="USD" />
            </div>
            <div className="form-col">
              <label>Live or Sandbox</label>
              <select>
                <option>Sandbox</option>
                <option>Live</option>
              </select>
            </div>
            <div className="form-col">
              <label>Enable/Disable</label>
              <select>
                <option>Disable</option>
                <option>Enable</option>
              </select>
            </div>
          </div>

          {/* Button */}
          <div className="form-actions">
            <button className="btn-update">Update</button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <span>
          Copyright © 2025 <b>Ample Markets</b>. All rights reserved.
        </span>
        <span className="version">Version 2.0</span>
      </div>
    </div>
  );
}

